import {
  usePropertyServicePropertyTypesList,
  usePropertyServicePropertyTypesListKey
} from '@insurance/api/queries'
import { useValidationsField } from '@insurance/hooks'
import { useQueryClient } from '@tanstack/react-query'
import { Select, SelectProps } from 'antd'
import { Col, Form } from 'antd'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { CategoryType } from './type'
import { formProps } from './utils'

type Props = {
  fieldKey: number
  category: CategoryType
} & SelectProps

export const ItemTypeField = ({
  fieldKey,
  category,
  disabled,
  ...props
}: Props) => {
  const { t } = useTranslation()
  const { required } = useValidationsField()
  const { ItemCategoryProps, itemsKey } = formProps(t)
  const queryClient = useQueryClient()

  const { data, isLoading } = usePropertyServicePropertyTypesList(
    { category, pageSize: 100 },
    [category],
    {
      enabled: !!category
    }
  )

  const isFetching = queryClient.isFetching({
    queryKey: [usePropertyServicePropertyTypesListKey, [{ category }]]
  })

  const selectOptions = useMemo(() => {
    return data?.results?.map((item) => ({
      label: item.name,
      value: item.code
    }))
  }, [data])

  return (
    <Col xs={24} md={12}>
      <Form.Item
        name={[fieldKey, category?.toLowerCase(), 'type']}
        label={t('type')}
        rules={[required]}
        dependencies={[itemsKey.name, fieldKey, ItemCategoryProps.name]}
      >
        <Select
          placeholder={t('type')}
          options={selectOptions}
          loading={isLoading || !!isFetching}
          className="w-full"
          allowClear
          showSearch
          optionFilterProp="label"
          disabled={!category || disabled}
          {...props}
        />
      </Form.Item>
    </Col>
  )
}
